import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream-dark border-y border-line" data-id="element-125" data-mp="1o2vk0ww891a9">
      <div className="max-w-4xl mx-auto" data-id="element-126" data-mp="223oddeaslqbs">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream-light border border-gold rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm" data-id="element-127" data-mp="222mzz36b0rqw">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1.5 bg-burgundy" data-id="element-128" data-mp="14h8tk5uw8gl2" />

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-cream border border-gold text-burgundy mb-8" data-id="element-129" data-mp="1j6501yhaxljk">
            <ShieldCheckIcon size={48} data-id="element-130" data-mp="qo9geail2ygo" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold uppercase mb-6 text-ink" data-id="element-131" data-mp="qmom8m06lhjc">
            🛡️ Full 7-Day Money-Back Guarantee
          </h2>

          <div className="space-y-6 text-lg text-ink-soft max-w-2xl mx-auto" data-id="element-132" data-mp="p01hi8cdj3a9">
            <p data-id="element-133" data-mp="tymi48vjfoz8">
              Open the entire 6-in-1 system. Explore all 5 bonuses. Use the
              material in your most challenging class this week.
            </p>
            <p className="font-medium text-ink" data-id="element-134" data-mp="yq4hwtltrjim">
              If you feel the material is not clear, practical, or useful for
              your teaching needs, contact us within 7 days.
            </p>
            <p className="text-burgundy font-bold text-xl" data-id="element-135" data-mp="62qimounmbvc">
              We will refund 100% of your money. No questions asked. No forms.
              No complications.
            </p>
            <p className="text-sm text-ink-muted mt-8" data-id="element-136" data-mp="ezsjcoytn7s8">
              Because if the material doesn't deliver the value we promise, we
              don't want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}